import { RetryStrategy } from '../index';

const neverRetryStrategy: RetryStrategy<any> = () => false;

export default neverRetryStrategy;
